import { render } from "./Pay.vue?vue&type=template&id=989562bc&scoped=true"
import script from "./Pay.vue?vue&type=script&lang=js"
export * from "./Pay.vue?vue&type=script&lang=js"

import "./Pay.vue?vue&type=style&index=0&id=989562bc&scoped=true&lang=css"

import exportComponent from "E:\\zzh\\zl-h5\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-989562bc"]])

export default __exports__